import * as React from "react"

export default function NoVehiclesIcon(props) {
  return (
    <svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.2 34v-3a7 7 0 017-7h3.5a7 7 0 017 7v3M23.95 24a5 5 0 100-10 5 5 0 000 10z"
        stroke={props.stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}